import { useContext, useEffect, useRef } from "react";
import { AppContext } from "../App";
import Products from "./Products";

function ProductsOnePage() {
	const { settings, courses, category, setCategory, getTranslatedString } =
		useContext(AppContext);
	const scrollTimeoutRef = useRef(null);

	useEffect(() => {
		const container = document.getElementById("main");
		if (!container) return;

		const handleScroll = () => {
			if (settings.menu.categories_menu_type != 2) return;
			clearTimeout(scrollTimeoutRef.current);
			scrollTimeoutRef.current = setTimeout(() => {
				syncCategoryByScroll(container);
			}, 80);
		};

		container.addEventListener("scroll", handleScroll, { passive: true });
		handleScroll();

		return () => {
			container.removeEventListener("scroll", handleScroll);
			clearTimeout(scrollTimeoutRef.current);
		};
	}, [courses, settings]); // eslint-disable-line react-hooks/exhaustive-deps

	const syncCategoryByScroll = (container) => {
		const boxes = Array.from(container.querySelectorAll(".category-box"));
		if (boxes.length == 0) return;

		// Pre-select the next category a bit earlier for smoother UX.
		const marker = container.scrollTop + Math.max(120, container.clientHeight * 0.2);
		let activeBox = boxes[0];
		for (const box of boxes) {
			if (box.offsetTop <= marker) activeBox = box;
			else break;
		}

		const activeId = activeBox?.id?.replace("category-", "");
		if (!activeId) return;

		for (const course of courses) {
			for (const courseCategory of course.categories) {
				if (String(courseCategory.id) == String(activeId)) {
					if (!category || category.id != courseCategory.id) setCategory(courseCategory);
					return;
				}
			}
		}
	};

	return (
		<>
			{courses &&
				courses.map((course, i) => (
					<div key={i}>
						{course.name && (
							<h3 className="course-title">{getTranslatedString(course, "name")}</h3>
						)}
						{course.categories.map((cat, n) => (
							<div key={n} id={"category-" + cat.id} className="category-box">
								<Products products={cat.products} category={cat} />
							</div>
						))}
					</div>
				))}
		</>
	);
}

export default ProductsOnePage;
